var exports = {
  "EK": "x7f9a0e16--50ed5f--suggests",
  "ZA": "x7f9a0e16--50ed5f--suggest",
  "jV": "x7f9a0e16--50ed5f--suggest--active",
};

module.exports = exports;
